// extracted by mini-css-extract-plugin
module.exports = {"gameIndicatorOff":"navigationregular_gameIndicatorOff__r8AY_","gameIndicatorOn":"navigationregular_gameIndicatorOn__AT1pw"};